"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));
var _config = _interopRequireDefault(require("../../config.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  init: function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _mixpanelBrowser["default"].init(_config["default"].mixpanelToken, {
      debug: process.env.NODE_ENV !== 'production',
      track_pageview: 'url-with-path',
      persistence: 'localStorage'
    });
  },
  trackEvent: function trackEvent(category, action, label, value) {
    var otherProperties = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var eventName = "".concat(action, " ( ").concat(category, " )");
    _mixpanelBrowser["default"].track(eventName, _objectSpread({
      category: category,
      action: action,
      label: label,
      value: value
    }, otherProperties));
  },
  setUserId: function setUserId(userId) {
    _mixpanelBrowser["default"].identify(userId);
  },
  setCustomDimension: function setCustomDimension(dimension, value) {
    _mixpanelBrowser["default"].people.set((0, _defineProperty2["default"])({}, dimension, value));
  }
};